const diffDate = function (fromDate, toDate) {
  return Math.abs(parseInt((fromDate - toDate) / (1000 * 60 * 60 * 24)));
};

module.exports = diffDate;



//////////////////
// WEBPACK FOOTER
// ./utils/diffDate.js
// module id = 1318
// module chunks = 0